import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import TextItemsDisplay from '@/components/TextItemsDisplay/TextItemsDisplay';
import countries from '@/utils/countries';

const VISIBLE_ITEMS_COUNT = 2;

interface CountryDisplayProps {
  value: string[];
  isArchived?: boolean;
}

const CountryDisplay: FC<CountryDisplayProps> = ({ value, isArchived }) => {
  const { i18n } = useTranslation();
  const items = useMemo(
    () => value.map((key: string) => countries.getName(key, i18n.language)!),
    [value, i18n.language]
  );

  return <TextItemsDisplay items={items} visibleItemsCount={VISIBLE_ITEMS_COUNT} isArchived={isArchived} />;
};

export default CountryDisplay;
